var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h1',{staticClass:"alert-heading"},[_vm._v("Authentication Error")]),_c('b-alert',{attrs:{"show":"","variant":"danger"}},[_vm._v(" "+_vm._s(_vm.error_message)+" ")]),_c('b-link',{attrs:{"to":"/auth","variant":"primary"}},[_vm._v(" Try again ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }